import { quillGuardCharacter } from './constants'

export const getPreheaderText = html => {
  const { body } = new DOMParser().parseFromString(html, 'text/html')

  return body.textContent.replaceAll(quillGuardCharacter, '')
}

const getChangeIndex = delta => delta.ops[0].retain || 0

export const isMentionAutocompletePick = (delta, previousChange) => {
  if (!previousChange) return false

  const insertions = delta.ops.filter(op => op.insert)
  const isSingleMention = insertions.length === 1 && insertions[0].insert.mention && !delta.ops.some(op => op.delete)

  if (!isSingleMention) return false

  const previousDeletions = previousChange.delta.ops.filter(op => op.delete)
  const isSingleDeletion =
    previousDeletions.length === 1 && previousChange.delta.ops.every(op => op.retain || op.delete)

  if (!isSingleDeletion) return false

  const deletionIndex = getChangeIndex(previousChange.delta)

  if (deletionIndex !== getChangeIndex(delta)) return false

  const deletedStart = previousChange.oldDelta.slice(deletionIndex, deletionIndex + 2)

  return deletedStart.ops.map(op => op.insert).join('') === '{{'
}
